import { render, staticRenderFns } from "./PaketKuesionerTambah.vue?vue&type=template&id=fd2742e0&"
import script from "./PaketKuesionerTambah.vue?vue&type=script&lang=js&"
export * from "./PaketKuesionerTambah.vue?vue&type=script&lang=js&"
import style0 from "./PaketKuesionerTambah.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports